// Fired whenever a filter/page query param changes via the helpers below, so
// components that read filters from the URL (e.g. the active-filter chips) can
// re-render — history.replaceState does not emit a popstate event.
export const FILTERS_CHANGED_EVENT = 'scfhp:filters-changed';

const emitFiltersChanged = () => {
  window.dispatchEvent(new Event(FILTERS_CHANGED_EVENT));
};

// Sets a query-string parameter on the current URL without navigating.
// Used by the paginationLayout renderer to keep `?page=N` shareable and by the
// filter dropdowns to keep the applied filters in the URL.
export const replaceSearchParam = (searchParam: string, value: string) => {
  const url = new URL(window.location.href);
  url.searchParams.set(searchParam, value);
  window.history.replaceState({}, '', url);
  emitFiltersChanged();
};

// Removes a query-string parameter from the current URL without navigating.
export const removeSearchParam = (searchParam: string) => {
  const url = new URL(window.location.href);
  url.searchParams.delete(searchParam);
  window.history.replaceState({}, '', url);
  emitFiltersChanged();
};
